import cl from 'classnames'
import styles from './styles.module.scss'

type DividerProps = React.HTMLAttributes<HTMLDivElement>

export const Divider = ({ className, ...props }: DividerProps) => (
  <div {...props} className={cl(styles.container, className)}></div>
)
